"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuggestionModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var SuggestionModal = /** @class */ (function (_super) {
    __extends(SuggestionModal, _super);
    function SuggestionModal(props) {
        var _this = _super.call(this, props) || this;
        _this.toggle = _this.toggle.bind(_this);
        return _this;
    }
    SuggestionModal.prototype.render = function () {
        var closeBtn = (0, jsx_runtime_1.jsx)("button", { className: "btn-close", onClick: this.toggle });
        return ((0, jsx_runtime_1.jsx)(React.Fragment, { children: (0, jsx_runtime_1.jsxs)(reactstrap_1.Modal, { className: "my-2 info-modal", isOpen: this.props.isSuggestionModalOpen, toggle: this.toggle, children: [(0, jsx_runtime_1.jsxs)(reactstrap_1.ModalHeader, { toggle: this.toggle, close: closeBtn, children: [(0, jsx_runtime_1.jsxs)("div", { className: "d-flex", children: [(0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)("img", { className: "mr-2 info-icon-selected", src: "/img/Flow-info-selected.svg", alt: "Info icon selected" }) }), (0, jsx_runtime_1.jsx)("div", { className: "text-blue-2 font-weight-medium", children: this.props.title })] }), this.props.header] }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalBody, { className: "pt-0 overflow-auto", children: this.props.children }), (0, jsx_runtime_1.jsx)(reactstrap_1.ModalFooter, { className: "d-flex flex-column", children: (0, jsx_runtime_1.jsx)("button", { type: "button", className: "btn btn-primary btn-add width-md-250 mb-1", onClick: this.toggle, children: "Ok, I understand" }) })] }) }));
    };
    SuggestionModal.prototype.toggle = function () {
        this.props.toggleSuggestionModal();
    };
    return SuggestionModal;
}(React.Component));
exports.SuggestionModal = SuggestionModal;
//# sourceMappingURL=SuggestionModal.js.map